import img1 from '../../images/team/Roman_Lahoda.jpg';
import img2 from '../../images/team/Anna_Prutnik.jpg';
import img3 from '../../images/team/Dmitry_Dramaretsky.jpg';
import img4 from '../../images/team/Natalia_Pavlova.jpg';
import img5 from '../../images/team/Roman_Korotaev.jpg';
import img6 from '../../images/team/Dina_Yermakova.jpg';
import img7 from '../../images/team/Aleksey_Dibikov.jpg';
import img8 from '../../images/team/Larisa_Shatil.jpg';
import img9 from '../../images/team/Liudmyla_Kozachenko.jpg';
import img10 from '../../images/team/Yevhenia_Mikhailova.jpg';

export default [
  {
    fullName: 'Roman Lahoda',
    firstName: 'Roman',
    secondName: 'Lahoda',
    position: 'Team Lead',
    photo: img1,
    linkedIn: '#',
    gitHub: 'https://github.com/Roman-Lahoda/',
    telegram: 'https://t.me/Roman_Lagoda5991',
  },
  {
    fullName: 'Anna Prutnik',
    firstName: 'Anna',
    secondName: 'Prutnik',
    position: 'Scrum master',
    photo: img2,
    linkedIn: '#',
    gitHub: 'https://github.com/AnnaPrutnik',
    telegram: 'https://t.me/AnnaPrutnik',
  },
  {
    fullName: 'Dmitry Dramaretsky',
    firstName: 'Dmitry',
    secondName: 'Dramaretsky',
    position: 'Developer',
    photo: img3,
    linkedIn: 'https://www.linkedin.com/in/dmitry-dramaretsky/',
    gitHub: 'https://github.com/DmitryDr-dev',
    telegram: 'https://t.me/dmitrydrm',
  },
  {
    fullName: 'Natalia Pavlova',
    firstName: 'Natalia',
    secondName: 'Pavlova',
    position: 'Developer',
    photo: img4,
    linkedIn: 'https://www.linkedin.com/in/natalia-pavlova/',
    gitHub: 'https://github.com/Lia-Pavlova',
    telegram: 'https://t.me/Lia_Pavlova',
  },
  {
    fullName: 'Roman Korotaev',
    firstName: 'Roman',
    secondName: 'Korotaev',
    position: 'Developer',
    photo: img5,
    linkedIn: 'https://www.linkedin.com/in/roman-korotaev-b20822221/',
    gitHub: 'https://github.com/RomanKorotaev',
    telegram: 'https://t.me/Roma_Kor',
  },
  {
    fullName: 'Dina Yermakova',
    firstName: 'Dina',
    secondName: 'Yermakova',
    position: 'Developer',
    photo: img6,
    linkedIn: 'https://www.linkedin.com/in/dina-yermakova-6aa94020b/',
    gitHub: 'https://github.com/YermakovaDina',
    telegram: 'https://t.me/dina_yermakova',

  },
  {
    fullName: 'Aleksey Dibikov',
    firstName: 'Aleksey',
    secondName: 'Dibikov',
    position: "Developer",
    photo: img7,
    linkedIn: 'https://www.linkedin.com/in/aleksey-dibikov-377a6921a/',
    gitHub: 'https://github.com/Aleksey-Dibikov',
    telegram: 'https://t.me/Di_Aleksey',
  },
  {
    fullName: 'Larisa Shatil',
    firstName: 'Larisa',
    secondName: 'Shatil',
    position: 'Developer',
    photo: img8,
    linkedIn: 'http://www.linkedin.com/in/LarisaShatillo/',
    gitHub: 'https://github.com/LarisaShatil',
    telegram: 'https://t.me/Larisa_Shatillo ',
  },
  {
    fullName: 'Liudmila Kozachenko',
    firstName: 'Liudmila',
    secondName: 'Kozachenko',
    position: 'Developer',
    photo: img9,
    linkedIn: 'https://www.linkedin.com/in/liudmila-kozachenko-16905bb7/',
    gitHub: 'https://github.com/Liucie',
    telegram: 'https://t.me/LiudmilaKozachenko',
  },
  {
    fullName: 'Yevhenia Mikhailova',
    firstName: 'Yevhenia',
    secondName: 'Mikhailova',
    position: 'Developer',
    photo: img10,
    linkedIn: '#',
    gitHub: 'https://github.com/EvgeniiaMikhailova',
    telegram: '#',
  },
];